"use client";

import { useSession } from "next-auth/react";
import { useLocale, useTranslations } from "next-intl";

export default function ArticleDate({ date }) {
    const locale = useLocale();
    const { data: session } = useSession();
    const t = useTranslations();

    let timezone;
    if (session?.user?.timezone) {
        timezone = session.user.timezone;
    } else {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    // Use native Intl.DateTimeFormat instead of moment-timezone
    const lastModification = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: timezone,
    }).format(new Date(date));

    return (
        <div className="flex items-center gap-1">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                viewBox="0 0 24 24"
            >
                <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M11 13h5m-8 0h.009M13 17H8m8 0h-.009M18 2v2M6 2v2m-3.5 8.243c0-4.357 0-6.536 1.252-7.89C5.004 3 7.02 3 11.05 3h1.9c4.03 0 6.046 0 7.298 1.354C21.5 5.707 21.5 7.886 21.5 12.244v.513c0 4.357 0 6.536-1.252 7.89C18.996 22 16.98 22 12.95 22h-1.9c-4.03 0-6.046 0-7.298-1.354C2.5 19.293 2.5 17.114 2.5 12.756zM3 8h18"
                    color="currentColor"
                ></path>
            </svg>
            {t("ArticleDate_updated_at", {
                date: lastModification,
            })}
        </div>
    );
}
